import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[disableControl]'
})
export class DisabledControlDirective {

  @Input() set disableControl( condicion: boolean ){
    const accion = condicion ? 'disable' : 'enable';
    this._ngControl.control[accion]();
  }

  constructor( private _ngControl: NgControl ) { }

}
